// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminDashboardController from "./admin_dashboard_controller"
application.register("admin-dashboard", AdminDashboardController)

import AgentCustomersTableController from "./agent_customers_table_controller"
application.register("agent-customers-table", AgentCustomersTableController)

import AgentPropertiesTableController from "./agent_properties_table_controller"
application.register("agent-properties-table", AgentPropertiesTableController)

import AgentsTableController from "./agents_table_controller"
application.register("agents-table", AgentsTableController)

import ApproveReservationController from "./approve_reservation_controller"
application.register("approve-reservation", ApproveReservationController)

import ClientPropertiesFilterController from "./client_properties_filter_controller"
application.register("client-properties-filter", ClientPropertiesFilterController)

import CustomerController from "./customer_controller"
application.register("customer", CustomerController)

import CustomersTableController from "./customers_table_controller"
application.register("customers-table", CustomersTableController)

import DeviceRegistrationController from "./device_registration_controller"
application.register("device-registration", DeviceRegistrationController)

import DevicesTableController from "./devices_table_controller"
application.register("devices-table", DevicesTableController)

import DocumentsController from "./documents_controller"
application.register("documents", DocumentsController)

import DynamicClausesController from "./dynamic_clauses_controller"
application.register("dynamic-clauses", DynamicClausesController)

import EnquiriesListController from "./enquiries_list_controller"
application.register("enquiries-list", EnquiriesListController)

import EnquiriesTableController from "./enquiries_table_controller"
application.register("enquiries-table", EnquiriesTableController)

import EnquiryModalController from "./enquiry_modal_controller"
application.register("enquiry-modal", EnquiryModalController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LoginController from "./login_controller"
application.register("login", LoginController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PermissionsController from "./permissions_controller"
application.register("permissions", PermissionsController)

import ProjectsTableController from "./projects_table_controller"
application.register("projects-table", ProjectsTableController)

import PropertiesTableController from "./properties_table_controller"
application.register("properties-table", PropertiesTableController)

import PropertyFiltersController from "./property_filters_controller"
application.register("property-filters", PropertyFiltersController)

import PropertyTermsController from "./property_terms_controller"
application.register("property-terms", PropertyTermsController)

import RepDocumentsController from "./rep_documents_controller"
application.register("rep-documents", RepDocumentsController)

import RepresentativesController from "./representatives_controller"
application.register("representatives", RepresentativesController)

import RequirementsController from "./requirements_controller"
application.register("requirements", RequirementsController)

import ReservationTermController from "./reservation_term_controller"
application.register("reservation-term", ReservationTermController)

import ReservationsTableController from "./reservations_table_controller"
application.register("reservations-table", ReservationsTableController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import VerificationDocumentsController from "./verification_documents_controller"
application.register("verification-documents", VerificationDocumentsController)
